export const DEFAULT_LOCATION = {
    lat: 41.55196720217189, 
    lng: 60.63132657279971
}